var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.127 11.7839C19.8004 11.7839 21.9676 9.34889 21.9676 6.3451C21.9676 3.34131 19.8004 0.90625 17.127 0.90625C14.4536 0.90625 12.2863 3.34131 12.2863 6.3451C12.2863 9.34889 14.4536 11.7839 17.127 11.7839ZM2.97266 1.50781C1.86809 1.50781 0.972656 2.40324 0.972656 3.50781V9.18913C0.972656 10.2937 1.86809 11.1891 2.97266 11.1891H8.65397C9.75854 11.1891 10.654 10.2937 10.654 9.18913V3.50781C10.654 2.40324 9.75854 1.50781 8.65397 1.50781H2.97266ZM2.97266 12.8711C1.86809 12.8711 0.972656 13.7665 0.972656 14.8711V20.5524C0.972656 21.657 1.86809 22.5524 2.97266 22.5524H8.65397C9.75854 22.5524 10.654 21.657 10.654 20.5524V14.8711C10.654 13.7665 9.75854 12.8711 8.65397 12.8711H2.97266ZM12.2861 14.8711C12.2861 13.7665 13.1816 12.8711 14.2861 12.8711H19.9674C21.072 12.8711 21.9674 13.7665 21.9674 14.8711V20.5524C21.9674 21.657 21.072 22.5524 19.9674 22.5524H14.2861C13.1816 22.5524 12.2861 21.657 12.2861 20.5524V14.8711Z",
    fill: "url(#paint0_linear_874_388)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_874_388",
    x1: 22.7254,
    y1: -0.161188,
    x2: 7.10982,
    y2: 19.4978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030AC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardColored);
export default __webpack_public_path__ + "static/media/dashboard-colored.0d60fe35eee88a21be95682437b2ef95.svg";
export { ForwardRef as ReactComponent };